import { render, staticRenderFns } from "./New_utensil.vue?vue&type=template&id=64ed7dc0&scoped=true&"
import script from "./New_utensil.vue?vue&type=script&lang=js&"
export * from "./New_utensil.vue?vue&type=script&lang=js&"
import style0 from "./New_utensil.vue?vue&type=style&index=0&id=64ed7dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed7dc0",
  null
  
)

export default component.exports